module.exports = __webpack_public_path__ + "static/world-af14e74f8b3bbc4aaa369e8e5a726ef7.jpg";